import React, { useState } from 'react';
import JobFormPage from '../JobFormPage';
import { Text } from 'library';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import BusinessAddressSelection from './components/BusinessAddressSelection';
import { client, consoleLogInDev } from 'shared';
import { useRequirementsAndPayContext } from '../RequirementsAndPayPage/context';
import { Qualification } from 'models';

export default function BusinessLocationPage({ name }: { name: string }) {
    const { goToNext, form } = useJobFormContext();
    const { scales, replaceAllScales } = useRequirementsAndPayContext();
    const { address } = form.fieldStates;
    const [isAddingAddress, setIsAddingAddress] = useState(false);

    function onGoToNext() {
        const addressIds = address.value.map((x) => x.id);
        client(`api/qualification/?address_ids=${addressIds}`)
            .then((response: Qualification[]) => {
                const newScales = scales.map((x) => {
                    const qualifications = x.qualifications;
                    response.forEach((i) => {
                        if (!qualifications.some((y) => y.qualification_id === i.id)) {
                            qualifications.push({
                                name: i.name,
                                option_id: null,
                                qualification_id: i.id,
                                value: 'true',
                            });
                        }
                    });
                    return {
                        ...x,
                        qualifications,
                    };
                });
                replaceAllScales(newScales);
            })
            .catch(consoleLogInDev);

        goToNext(name);
    }

    return (
        <JobFormPage
            title="Select the locations for this job."
            onNextClicked={() => onGoToNext()}
            nextDisabled={!address.value || !address.value.length}
            hideActionButtons={isAddingAddress}
            id={name}
        >
            <div style={{ marginTop: 30 }} />

            <Text textStyle={{ marginTop: 40 }} variant="h2">
                Addresses
            </Text>
            <BusinessAddressSelection isAddingAddress={isAddingAddress} setIsAddingAddress={setIsAddingAddress} />
        </JobFormPage>
    );
}
